import { generalConstants } from "@/utils/constants";
import { client } from "../utils/netlify";
import { reportError } from "./errorHelper";

export const customerOrderList = async (request) => {
  try{
    let resp = await client("customer-order-list", request)
    return resp;
  }catch(error){
    reportError("Error in customerOrderList");
    reportError(error)
  }
};

export const customerOrder = async (request) => {
  try{
    let resp = await client("customer-order", request)
    return resp;
  }catch(error){
    reportError("Error in customerOrder");
    reportError(error)
  }
}

export const getOrderStatus = async (order) => {
  let statusShow = 0;
  if (order && order.lineItems && order.lineItems.edges && order.lineItems.edges.length) {
    for (let i = 0; i < order.lineItems.edges.length; i++) {
      let tags = order.lineItems.edges[i]?.node?.variant?.product?.tags;
      let productType = order.lineItems.edges[i]?.node?.variant?.product?.productType;
      if (!(tags && Array.isArray(tags) && tags.includes(generalConstants.product_type_donation_tag)) && !(generalConstants.gift_card_type.includes(productType))) {
        statusShow = 1;
      }
    }
  } else {
    statusShow = 1;
  }
  if (statusShow) {
    let status = order.fulfillmentStatus.toUpperCase() + '_' + order.financialStatus.toUpperCase();
    if (generalConstants.order_status[status]) {
      let formattedOrderstatus = generalConstants.order_status[status];
      if (order.canceledAt != null) {
        formattedOrderstatus = generalConstants.order_status['CANCELLED'];
        return {formattedOrderstatus, status};
      }
      else return {formattedOrderstatus, status};
    }
    return generalConstants.order_status['DEFAULT'];
  }
  return '';
}

export const getLineItemStatusByOrderId = async (request) => {
  try{
    let resp = await client("order-lineitem-details", request)
    return resp;
  }catch(error){
    reportError("Error in getLineItemStatusByOrderId");
    reportError(error)
  }
}

// list of colors for differnt orderStatus
export const orderStatusColors = {
  "processing": "#FF9900",
  "refunded": "#979797",
  "shipped": "#42BE65",
  "returned": "#979797",
  "delivered": "#42BE65",
  "donated":  "#42BE65",
  "completed" : "#42BE65",
  "partially refunded": "#FF9900",
  "partially shipped": "#FF9900",
  "canceled": "#979797",
 };

 // list of colors for based on shopify order status
export const shopifyOrderStatusColors = {
  "unfulfilled_paid": "#FF9900",
  "unfulfilled_partially_refunded": "#FF9900",
  "unfulfilled_partially_paid": "#FF9900",
  "fulfilled_paid": "#42BE65",
  "fulfilled_partially_refunded": "#42BE65",
  "partially_fulfilled_partially_paid": "#FF9900",
  "partially_fulfilled_paid": "#FF9900",
  "unfulfilled_refunded": "#979797", 
  "fulfilled_refunded": "#979797",
  "partially_fulfilled_partially_refunded": "#FF9900",
 };